
      import API from "!../../../style-loader/dist/runtime/injectStylesIntoLinkTag.js";
      import insertFn from "!../../../style-loader/dist/runtime/insertBySelector.js";
      import content from "!!../../../file-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../@ally/next-webpack-recipes/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!./_datepicker.css";
      

var options = {"attributes":{"data-remote-style":"ally-next-remote-account-details"}};


      options.insert = insertFn.bind(null, "head");
    

var update = API(content, options);



export default {}